import Vue from 'vue';
import VueTouch from 'vue-touch';
import App from './App.vue';

import router from './router/index';
import store from './store/index';
import i18n from './plugins/i18n';
import './plugins/vuelidate';

import '../assets/styles/app.scss';

Vue.use(VueTouch);

new Vue({
	...App,
	store,
	router,
	i18n,
}).$mount('#app');
